import { render } from "./pediatrics_imaging.vue?vue&type=template&id=26d6f4f4&scoped=true"
import script from "./pediatrics_imaging.vue?vue&type=script&lang=js"
export * from "./pediatrics_imaging.vue?vue&type=script&lang=js"

import "./pediatrics_imaging.vue?vue&type=style&index=0&id=26d6f4f4&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d6f4f4"]])

export default __exports__